import './index.scss';

import { createHistory } from 'history';
import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { Router, Route, useRouterHistory } from 'react-router';
import { syncHistoryWithStore, routerMiddleware, push } from 'react-router-redux';
import ga from 'react-ga';

import reducers from 'redux/configureStore';
import Routes from './routes';
import Fetch from 'network';
import { GA_TRACKING_CODE } from 'config';

// ga.initialize(GA_TRACKING_CODE);

const analytics = store => next => action => {
  if (action.noGA) {
    return next(action);
  }
  if (action.type.length > 0 && action.type[0] !== '@') {
    ga.event({
      category: action.type.split('_')[0],
      action: action.type
    });
  }
  return next(action);
};

const appHistory = useRouterHistory(createHistory)({
  queryKey: false
});
const historyMiddleware = routerMiddleware(appHistory)

// const middleWares = composeMiddleware(thunk, promise, batchedUpdatesMiddleware);

const store = createStore(
	// enableBatching(reducers),
	reducers,
	applyMiddleware(thunk, historyMiddleware, analytics)
);

window.store = store;

setInterval(() => {
  Fetch.clear();
}, 15*1000*60);

const history = syncHistoryWithStore(appHistory, store);

render(
	<Provider store={store}>
    <Routes history={history} />
  </Provider>,
  document.getElementById('app')
);



/** WEBPACK FOOTER **
 ** ./index.js
 **/